import variable from "../variable";

(function ($) {

    $(document).ready(function () {
        $('.carousel-news-grid').each(function (index, el) {
            computeHeightPostNewsGrid(el);
        });
    });

    $(window).resize(function () {
        $('.carousel-news-grid').each(function (index, el) {
            computeHeightPostNewsGrid(el);
        });
    });
    
    function computeHeightPostNewsGrid(el)
    {
        if ($(window).width() >= variable('bp_fullpage')) {
            var height_footer = getHeightFooterNewsGrid(el);
            var height_section = $(window).height();
            var el_post_gird = $(el).find('.news-container')[0];
            $(el_post_gird).height(height_section - height_footer);
        }
    }
    
    function getHeightFooterNewsGrid(el)
    {
        var el_footer = $(el).find('.social-wrap');
        var height = $(el_footer).outerHeight();
        return (typeof height == 'number')?height:0;
    }
})(jQuery);